import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'resend-invitation',
    templateUrl: './resend-invitation.component.html',
    styleUrls: ['./resend-invitation.component.scss'],
})
export class ResendInvitationComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
